import React from 'react';

// import Protect from 'react-app-protect';
import 'react-app-protect/dist/index.css';

import './App.css';
import MetaTags from 'react-meta-tags';
import PosterList from './component/PosterList';

function App() {


  return (
    <>
    {/* <Protect sha512='741e6a63ff02bf824a8aed4c9983fd494b093d2a263906195fc7d21e1e8f8291e551561b4bee40eee6df1fee479e4e3d745fca987b45c679d085aa664440d7f6'
      blur={true}
      boxTitle="Expo 2021"
      buttonLabel="Login"
      styles={{
        input: { borderRadius: '0.25rem', width: '100%', margin: '1rem auto', padding: '0.5rem' },
        header: { fontSize: '1.25em', padding: 'auto 2rem', width: '25rem', borderTopRightRadius: '0.25rem' },
        button: { borderRadius: '0.25rem', padding: '0.25rem 1rem', border: '0.05rem solid #666666'}
      }}
    >     */}
    <MetaTags>
      <title>Expo 2021</title>
      <meta name="DESCRIPTION" content="The Chinese University of Hong Kong (CUHK) is a top Hong Kong university with strong research emphasis. The university aims to bring together China and the West." />
      <meta name="KEYWORDS" content="Chinese university, university in hong kong, cuhk, hong kong university, university research, study in hong kong, hong kong university, study in hong kong, university study, top university in hong kong, best university, postgraduate studies, undergraduate studies, graduate school, Chinese university, research degree, university study, hk, mba, emba, hong kong universities" />
      <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
    </MetaTags>
    <div className="App">
      <PosterList></PosterList>
    </div>
    {/* </Protect> */}
    </>
  );
}

export default App;
